import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { Observable, Subscription, of } from 'rxjs';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { ReguleringService } from '../regulering.service';

@Component({
  selector: 'app-applyChangesDetail-popup',
  templateUrl: './applyChangesDetail-popup.component.html',
  styleUrls: ['./applyChangesDetail-popup.component.css']
})
export class ApplyChangesDetailComponent implements OnInit {
 
  combObs$ = new Observable()
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];
  onShowUnit: EventEmitter<ActionButtonEvent>;
  onShowUnitSubscription: Subscription;
  columnSettings: ColumnSetting[] = [
    {
      columnId: 'systemName',
      name: 'Name'
    },
    {
      columnId: 'systemId',
      name: 'id'
    },
    {
      columnId: 'siteId',
      name: 'site'
    },
    {
      columnId: 'status',
      name: 'Status'
    }
    ]
 
  sortArray = ['Name','Number','Machine','Selection','Required Quantity',"Available Quantity"]
  constructor(
    private regulerinService : ReguleringService,
    public dialogRef: MatDialogRef<ApplyChangesDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
      console.log(data)
      
     this.combObs$ = this.regulerinService.getApplyChangesRefrences(data)
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  genEmail(id){
    console.log(id)
  }
  ngOnInit() {
  }

}
